import { HttpClient } from 'api/http-client';
import {
  CustomRevenueRecognitionConfigApi,
  FinancialNotificationConfig,
  RevenueRecognitionConfigApi,
  UpdateFinancialAlertPayload,
} from './types';

class ProjectAccountingHttpClient extends HttpClient {
  public getFinancialNotificationConfig(): Promise<
    FinancialNotificationConfig[]
  > {
    return this.get('/account-notification-config');
  }

  public updateFinancialNotificationConfig(
    configId: number,
    payload: UpdateFinancialAlertPayload | FinancialNotificationConfig,
  ): Promise<FinancialNotificationConfig[]> {
    return this.put(`/account-notification-config/${configId}`, payload);
  }

  public getRevenueRecognitionConfig(): Promise<RevenueRecognitionConfigApi[]> {
    return this.get('/revenue-recognition-config');
  }

  public updateRevenueRecognitionConfig(
    payload: Pick<
      RevenueRecognitionConfigApi,
      'financialContractType' | 'revenueRecognitionType'
    >,
  ): Promise<void> {
    return this.put('/revenue-recognition-config', payload);
  }

  public getCustomRevenueRecognitionConfig(
    includeProjects?: boolean,
  ): Promise<CustomRevenueRecognitionConfigApi[]> {
    return this.get(
      `/revenue-recognition-config/custom${
        includeProjects ? '?includeProjects=true' : ''
      }`,
    );
  }

  public createCustomRevenueRecognitionConfig(
    payload: CustomRevenueRecognitionConfigApi,
  ): Promise<void> {
    return this.post('/revenue-recognition-config/custom', payload);
  }

  public updateCustomRevenueRecognitionConfig(
    customRevenueRecognitionId: number,
    payload: CustomRevenueRecognitionConfigApi,
  ): Promise<void> {
    return this.put(
      `/revenue-recognition-config/custom/${customRevenueRecognitionId}`,
      payload,
    );
  }

  public deleteCustomRevenueRecognitionConfig(
    customRevenueRecognitionId: number,
  ): Promise<void> {
    return this.delete(
      `/revenue-recognition-config/custom/${customRevenueRecognitionId}`,
    );
  }
}

export const ProjectAccountingAPI = new ProjectAccountingHttpClient();
